import utility from "src/utils/utility"
import { AppText, GridContainer } from "src/style"
import { AccountDeletionContainer } from "src/component"
import Lottie from "lottie-react";
import successGif from "src/assets/gif/success.json";

const AcctDeleteCompletion = () => {
    
    return (
        <>
            <AccountDeletionContainer width='38' minHeight='25'>
                <GridContainer>
                    <GridContainer width="20" topMargin="-2">
                        <Lottie animationData={successGif} loop={true} />
                    </GridContainer>
                    <AppText textSize="2" fontWeight="700" topMargin="-2">Account Deleted</AppText>
                </GridContainer>
            </AccountDeletionContainer>
        </>
    )
}

export default utility.routeData('delete-completion', 'Acct Delete Completion', <AcctDeleteCompletion/>)